import React from 'react';
import PropTypes from 'prop-types';
import CardDefault from '@components/ReviewCard';

function ReviewsList({ reviews, showBreakdown, card }) {
  const Card = card || CardDefault;
  return reviews.map(
    ({
      id,
      userAvatar,
      generalScore,
      food,
      service,
      speed,
      userName,
      description,
      registeredDate,
      orderCount,
      reviewCount,
    }) => {
      const ratingProps = showBreakdown ? { food, service, speed } : {};
      return (
        <Card
          key={id}
          image={userAvatar}
          score={generalScore}
          name={userName}
          description={description}
          date={registeredDate}
          orderCount={orderCount}
          reviewCount={reviewCount}
          {...ratingProps}
        />
      );
    },
  );
}

ReviewsList.propTypes = {
  reviews: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      userAvatar: PropTypes.string,
      generalScore: PropTypes.number,
      food: PropTypes.number,
      service: PropTypes.number,
      speed: PropTypes.number,
      userName: PropTypes.string,
      description: PropTypes.string,
      registeredDate: PropTypes.string,
    }),
  ).isRequired,
  showBreakdown: PropTypes.bool,
  card: PropTypes.node,
};

ReviewsList.defaultProps = {
  showBreakdown: false,
};

export default React.memo(ReviewsList);
